import { Logger, undefinedCheck } from '@sitecore-search/common';
import EventContext from './eventContext.js';
import { buildEventEntities, track, validateEntities } from './eventUtils.js';
/**
 * @desc Sent when user clicks on a widget's entity
 * @param rfkId
 * @param entity
 * @param context
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackSearchClickEntityEvent = async (rfkId, entity, { actionCause, index, request, items }) => {
    let eventEntities = [];
    if (entity && items) {
        eventEntities = buildEventEntities(entity, items);
        if (eventEntities && !validateEntities(eventEntities)) {
            Logger.warn('trackEvent :::', 'A field is missing on one or more of the items provided');
            return;
        }
    }
    if (actionCause && actionCause === 'entity' && undefinedCheck(index)) {
        Logger.warn('trackEvent :::', 'Field index is mandatory for widget click entity events and is having invalid/missing value');
        return;
    }
    const params = {
        name: 'widget',
        action: 'click',
        action_cause: actionCause,
        value: {
            entity,
            rfk_id: rfkId,
            index,
            entities: eventEntities,
            request,
            context: EventContext.toJson(),
        },
    };
    return track(params);
};
/**
 * @desc Sent when user clicks a suggestion(category, keyphrase, other)
 * @param rfkId
 * @param entity
 * @param request
 * @param filters
 * @returns {Promise<*>}
 */
export const trackSearchSuggestionClickEvent = async (rfkId, entity, { request, filters }) => {
    const params = {
        name: 'widget',
        action: 'click',
        action_cause: 'suggestion',
        value: {
            entity,
            rfk_id: rfkId,
            request,
            filters,
            context: EventContext.toJson(),
        },
    };
    return track(params);
};
/**
 * @desc Sent when user clicks on an facet/filter button
 * @param rfkId
 * @param entity
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackSearchClickFacetEvent = async (rfkId, entity, { index, request, filters }) => {
    const params = {
        name: 'widget',
        action: 'click',
        action_cause: 'filter',
        value: {
            rfk_id: rfkId,
            entity,
            index,
            request,
            filters,
            context: EventContext.toJson(),
        },
    };
    return track(params);
};
/**
 * @desc Sent when user views widget, entity, page.
 * @param rfkId
 * @param entity
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackViewEvent = async (rfkId, entity, { request, items } = {}) => {
    let eventEntities = [];
    if (entity && items) {
        eventEntities = buildEventEntities(entity, items);
        if (eventEntities && !validateEntities(eventEntities)) {
            Logger.warn('trackEvent :::', 'A field is missing on one or more of the items provided');
            return;
        }
    }
    const params = {
        action: 'view',
        name: 'widget',
        value: {
            entity,
            rfk_id: rfkId,
            request,
            entities: eventEntities,
            context: EventContext.toJson(),
        },
    };
    return track(params);
};
